document.addEventListener("DOMContentLoaded", function () {
  const ppPage = document.querySelector(".page-template-past-projects");

  // escape hatch
  if (!ppPage) return;

  const filterLinks = document.querySelectorAll(".project-type-value");
  const rows = document.querySelectorAll(".project-table tbody tr");
  const sortSelect = document.querySelector(".project-sort select");

  // FILTERING
  filterLinks.forEach((link) => {
    link.addEventListener("click", () => {
      // Remove 'active' class from all
      filterLinks.forEach((l) => l.classList.remove("active"));
      link.classList.add("active");

      const filter = link.dataset.type;

      rows.forEach((row) => {
        if (filter === "all" || row.classList.contains(`type-${filter}`)) {
          row.style.display = "";
        } else {
          row.style.display = "none";
        }
      });

      // Re-sort the visible rows after filtering
      sortSelect.dispatchEvent(new Event("change"));
    });
  });

  // SORTING
  sortSelect.addEventListener("change", () => {
    const rowsArray = Array.from(rows).filter(
      (row) => row.style.display !== "none",
    );
    const value = sortSelect.value;

    const getNumber = (row, selector) => {
      const text = row.querySelector(selector)?.textContent || "";
      const number = parseInt(text.replace(/[^0-9]/g, ""), 10);
      return isNaN(number) ? 0 : number;
    };

    rowsArray.sort((a, b) => {
      if (value === "sqft-h2l") {
        return getNumber(b, ".sf") - getNumber(a, ".sf");
      }
      if (value === "sqft-l2h") {
        return getNumber(a, ".sf") - getNumber(b, ".sf");
      }
      if (value === "year-o2n") {
        return getNumber(a, ".year") - getNumber(b, ".year");
      }
      if (value === "year-n2o") {
        return getNumber(b, ".year") - getNumber(a, ".year");
      }
    });

    const tbody = document.querySelector(".project-table tbody");
    rowsArray.forEach((row) => tbody.appendChild(row));
  });

  // Trigger sort once on page load.
  sortSelect.dispatchEvent(new Event("change"));

  // RESPONSIVE TABLE SHADOWS
  const wrapper = document.querySelector(".project-list");
  const container = document.querySelector(".project-table-container");

  function updateScrollIndicators() {
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;

    // Can scroll left if not at start
    wrapper.classList.toggle("can-scroll-left", scrollLeft > 0);

    // Can scroll right if not at end
    wrapper.classList.toggle(
      "can-scroll-right",
      scrollLeft < scrollWidth - clientWidth - 1,
    );
  }

  // Check on load
  updateScrollIndicators();

  // Check on scroll
  container.addEventListener("scroll", updateScrollIndicators);

  // Check on resize (in case content width changes)
  window.addEventListener("resize", updateScrollIndicators);
});
